import { FC, PropsWithChildren } from "react";

import { Stack } from "@mui/material";

import { FormTypography } from "../../../../components/forms-design-system/FormTypography";
import { GHOST_PREVIEW_OPACITY } from "../../../LiveFormEditor/LivePreview/ghostPreview.constant";

type Props = PropsWithChildren<{
  title: string;
  isGhostPreview?: boolean;
  dataTest?: string;
}>;

export const FormV2Step2SectionWrapper: FC<Props> = ({ title, children, isGhostPreview, dataTest }) => {
  return (
    <Stack
      gap={2}
      sx={{ ...(isGhostPreview && { opacity: GHOST_PREVIEW_OPACITY }) }}
      {...(dataTest && { "data-test": dataTest })}
    >
      <FormTypography variant="h6" vibe="intense">
        {title}
      </FormTypography>
      {children}
    </Stack>
  );
};
